export default "__VITE_ASSET__CdC6ebpl__"